import { AiFillCaretLeft } from "react-icons/ai"; 
import { BiSave } from "react-icons/bi"; 
import CxIcon from '../../cx/CxIcon';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import CxState from '../../cx/CxState';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import { getStoreValue, setStoreValue } from "../../gx/GxStore";
import GxForm from '../../gx/GxForm';


const MxSettBranchGeneral = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  let r_form = React.useRef(null);

  const rf_boShowBranchDataOnly = React.useRef(null);

  const r_snack_save = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
    let record = {};
    record['txScopeKey'] = "BRANCH"; record['txScopeVal'] = getStoreValue('StoreSession', 'inBranch');    
    Promise.all([FxFetch.doJsonX('sett/app/r', record)]).then((result) => {
      if (result[0]) {
        rf_boShowBranchDataOnly.current.setVal(result[0][0].boShowBranchDataOnly);
      }
    });
  }

  const formSaveCustom = async () => {
    let filter = { "inBranch": getStoreValue('StoreSession', 'inBranch'), };
    let record = {};
    record['txScopeKey'] = "BRANCH"; record['txScopeVal'] = getStoreValue('StoreSession', 'inBranch');    
    
    record['boShowBranchDataOnly'] = rf_boShowBranchDataOnly.current.getVal();
    setStoreValue('StoreSession', 'boShowBranchDataOnly', rf_boShowBranchDataOnly.current.getVal());

    Promise.all([FxFetch.doJsonF("sett/app/u", filter, record)]).then((result) => {
      if (result[0]) {
        if (result[0].theValue === 'OK') {
          r_snack_save.current.setOpen(true);
        }
      }
    });

    r_snack_save.current.setOpen(true);
  }

  return (
    <div>
      <GxForm
        moduleName={trans('field.general')}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} frontIcon={<AiFillCaretLeft/>} />} classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save_and_exit')} />
          </div>
        }
      >
        <CxState mode='checkbox' xref={rf_boShowBranchDataOnly} label={trans('field.sett_branch_data_only')} dbfield="boShowBranchDataOnly" />

      </GxForm>

      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} onClose={() => navBack()} />
    </div>
  );

}

export default MxSettBranchGeneral;
